// 前置条件-操作类型
export const operationTypeOptions = [
  {
    label: '满金额',
    value: 'FULL_AMOUNT'
  },
  {
    label: '满款数',
    value: 'FULL_PAYMENT'
  },
  {
    label: '满数量',
    value: 'FULL_QUANTITY'
  }
];

// 前置条件-起订包装单位
export const startPkgOptions = [
  {
    label: 'KAR',
    value: 'KAR'
  },
  {
    label: 'BX2',
    value: 'BX2'
  },
  {
    label: 'BX1',
    value: 'BX1'
  },
  {
    label: 'PCS',
    value: 'PCS'
  }
];

// 前置条件-需满金额单位
export const fullMoneyOptions = [
  {
    label: '元',
    value: 'YUAN'
  }
];

// 前置条件-需满单位-包装
export const fullPkgOptions = [
  {
    label: 'KAR',
    value: 'KAR'
  },
  {
    label: 'BX2',
    value: 'BX2'
  },
  {
    label: 'BX1',
    value: 'BX1'
  },
  {
    label: 'PCS',
    value: 'PCS'
  }
];

// 前置条件-需满单位-款数
export const fullTypeOptions = [
  {
    label: '货号',
    value: 'ARTICLE_NUMBER'
  },
  {
    label: '料号',
    value: 'ITEM_NUMBER'
  }
];

// 活动类型-优惠类型
export const activityTypeOptions = [
  {
    label: '满减',
    value: 'FULL_SUB'
  },
  {
    label: '满赠',
    value: 'FULL_GWP'
  },
  {
    label: '直降',
    value: 'DIRECT_DESCENT'
  },
  {
    label: '秒杀',
    value: 'SECKILL'
  },
  
];

// 门槛规则-操作类型（活动类型=直降时）
export const directSubRuleOperationOptions = [
  {
    label: '特价',
    value: 'SPECIAL_PRICE'
  },
  {
    label: '折扣',
    value: 'DISCOUNT'
  }
];

// 权益信息-优惠操作类型（活动类型=满减时）
export const fullSubRightsOperationOptions = [
  {
    label: '减金额',
    value: 'REDUCTION_AMOUNT'
  },
  {
    label: '折扣率',
    value: 'DISCOUNT_RATE'
  }
];

// 权益信息-优惠操作类型（活动类型=满赠时）
export const fullGwpRightsOperationOptions = [
  {
    label: '指定',
    value: 'TARGET'
  },
  {
    label: '自选',
    value: 'CHOOSE_SELF'
  },
  {
    label: '料号满A赠A',
    value: 'ITEM_FULL_A_TO_A'
  },
  {
    label: '料号满A赠B',
    value: 'ITEM_FULL_A_TO_B'
  },
  {
    label: '货号满A赠A',
    value: 'ARTICLE_FULL_A_TO_A'
  },
  {
    label: '货号满A赠B',
    value: 'ARTICLE_FULL_A_TO_B'
  }
];

// 权益信息-优惠类型（活动类型=满赠时)
export const fullGwpTimesOptions = [
  {
    label: '循环满赠',
    value: 'FULL_QUANTITY'
  },
  {
    label: '赠送一次',
    value: 'GIFT_ONCE'
  }
];
// 权益信息-优惠类型（活动类型=满赠时)
export const SECKILLRightsOperationOptions = [
  {
    label: '特价价格',
    value: 'SPECIAL_PRICE'
  },
  {
    label: '特价扣率',
    value: 'DISCOUNT'
  }
];

// 权益信息-优惠类型（活动类型=满减时)
export const fullSubTimesOptions = [
  {
    label: '循环满减',
    value: 'CYCLIC_FULL_DECREMENT'
  },
  {
    label: '常规满减',
    value: 'REGULAR_FULL_REDUCTION'
  }
];

// 前置条件/门槛规则，不同类型对应选项
export const fullOptionsMap = {
  FULL_AMOUNT: fullMoneyOptions,
  FULL_PAYMENT: fullTypeOptions,
  FULL_QUANTITY: fullPkgOptions
};

// 前置条件/门槛规则，不同类型对应jsonData中的数值key
export const fullOptionsValueMap = {
  FULL_AMOUNT: 'moneyUnit',
  FULL_PAYMENT: 'itemUnit',
  FULL_QUANTITY: 'packageUnit'
};

// 不同活动类型对应的权益信息第一列选项
export const rightsOperationsOptionsMap = {
  FULL_SUB: fullSubRightsOperationOptions,
  FULL_GWP: fullGwpRightsOperationOptions,
  SECKILL: SECKILLRightsOperationOptions
};

// 不同活动类型对应的权益信息第一列选项jsonData中的key
export const rightsOperationsOptionsKeyMap = {
  FULL_SUB: 'reductionOption',
  FULL_GWP: 'giftOption',
  SECKILL:'directDescentOption'
};

// 不同活动类型对应的权益信息第二列选项
export const rightsOperationsTimesOptionsMap = {
  FULL_SUB: fullSubTimesOptions,
  FULL_GWP: fullGwpTimesOptions,
};

// 不同活动类型对应的权益信息第二列选项jsonData中的key
export const rightsOperationsTimesOptionsKeyMap = {
  FULL_SUB: 'reductionDiscount',
  FULL_GWP: 'giftDiscount'
};
